<section class="payment-item-modal">
  <div class="payment-item-modal__header">
    <h1 class="payment-item-modal__title">
      {{ 'shop-settings.subscription.paymentMethod.addPaymentMethodModal.title' | translate }}
    </h1>
    <button class="payment-item-modal__close-btn" (click)="modalClose()">
      <app-icon class="payment-item-modal__close-icon" [icon]="iconName.CLOSE" />
    </button>
  </div>
  <app-add-payment-content (closeListener)="modalClose()" />
</section>
